import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/expertise-experience.png";
import { Helmet } from "react-helmet";

class ExpertiseExperience extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>
            Expertise &amp; Experience | Enterprise Delivery, Technology Depth & Industry Knowledge | Avani Cimcon
          </title>
          <meta
            name="description"
            content="Avani Cimcon combines enterprise delivery experience, global exposure, product engineering, and deep technology expertise across industries and platforms."
          />
          <meta
            name="keywords"
            content="expertise and experience, enterprise delivery, project managers, system architects, business analysts, application expertise, software professionals, engineering experts, industry expertise, global delivery, product engineering, modernization"
          />
          <link rel="canonical" href="https://www.avanicimcon.com/expertise-experience" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Expertise & Experience</h1>
            <h5>What decades of delivery experience means for enterprise buyers</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p>
                This page is one of the strongest trust assets on the site because it shows how
                Avani Cimcon's capability was built. The company does not claim expertise in the
                abstract; it has accumulated it through industries served, products engineered, and
                enterprise systems delivered over time.
              </p>
              <p>
                That matters today because modernization is rarely a greenfield problem. Buyers need
                a partner who understands legacy systems, business workflows, delivery pressure, and
                the realities of introducing new technology into an operating enterprise.
              </p>

              <div className="shadow-sm p-3">
                <h4 className="text-primary mb-3 font-weight-bold">Our people</h4>

                <p>
                  Avani Cimcon Technologies is comprised of a skilled team of experienced,
                  techno-savvy software professionals with long-term domain expertise. They
                  effectively add value at every stage of the Software Development Life Cycle.
                  From a resource functionality perspective, that means the team can support
                  analysis, architecture, delivery, QA, implementation, and ongoing evolution.
                </p>

                <ul>
                  <li className="mb-3">
                    Business analysts
                    <ul>
                      <li>Specification and requirements documentation</li>
                    </ul>
                  </li>
                  <li className="mb-3">
                    QA resources
                    <ul>
                      <li>Expertise to develop and implement testing strategies</li>
                    </ul>
                  </li>
                  <li className="mb-3">Programming resources</li>
                  <li className="mb-3">DBA resources for database management</li>
                  <li className="mb-3">
                    System administrators for implementation and remote server management
                  </li>
                  <li>Project Managers/System Architects</li>
                </ul>
                <p>
                  As we have a significant international reach we’ve learned how to work with many
                  groups from different cultures and different regions of the world. Thus, we enjoy
                  rewarding relationships based on mutual trust and earned professional respect.{" "}
                </p>
              </div>

              <div className="shadow-sm p-3 mt-4">
                <h4 className="text-primary mb-3 font-weight-bold">Why the breadth matters now</h4>

                <p>
                  The mix of technologies, methods, and industries matters because enterprise
                  modernization often requires more than one kind of expertise at once. A legacy
                  platform might need architecture support, data work, QA discipline, and a product
                  mindset before AI can be introduced safely.
                </p>
                <p>
                  That breadth reduces modernization risk because the team can see dependencies,
                  preserve what still works, and sequence change in a way that respects the business
                  as well as the code. It also makes AI transformation safer because new
                  capabilities can be layered onto existing workflows rather than imposed on top of
                  gaps in delivery knowledge.
                </p>

                <ul>
                  <li className="mb-3">Requirements analysis and documentation services for complex systems</li>
                  <li className="mb-3">System design and architecture services for enterprise software</li>
                  <li className="mb-3">Product and web design services that support usable workflows</li>
                  <li className="mb-3">Development and programming services across legacy and modern stacks</li>
                  <li className="mb-3">DBA and implementation services for operational reliability</li>
                  <li className="mb-3">QA planning and testing services for safe release control</li>
                  <li className="mb-3">
                    System administration, implementation and maintenance services that support
                    long-term ownership
                  </li>
                  <li>Porting services</li>
                </ul>
                <p className="mb-0">
                  This is the background behind the company's work in{" "}
                  <Link to="/travel-hospitality">travel</Link>,{" "}
                  <Link to="/insurance">insurance</Link>,{" "}
                  <Link to="/healthcare">healthcare</Link>,{" "}
                  <Link to="/legal">legal</Link>, and product heritage such as{" "}
                  <Link to="/dxchange">DXchange</Link> and{" "}
                  <Link to="/biz-rule-engine">BizRuleEngine</Link>. For evidence beyond the
                  technology list, see the{" "}
                  <Link to="/international-projects">international projects</Link> and{" "}
                  <Link to="/domestic-projects">domestic projects</Link> pages.
                </p>
              </div>
            </div>

            <table className="table table-bordered mt-4">
              <tbody>
                <tr>
                  <th className="bg-light text-nowrap">Application Expertise</th>
                  <td>
                    N-tier Application, Internet / Ecommerce Applications, Rational Unified Process,
                    Microsoft Solutions Framework, DotNetNuke, Kentico
                  </td>
                </tr>

                <tr>
                  <th className="bg-light text-nowrap">Microsoft Technologies</th>
                  <td>.NET, IIS, COM, DCOM, MSXML, Remoting, ASP.NET</td>
                </tr>

                <tr>
                  <th className="bg-light">Java Technologies</th>
                  <td>J2EE, Struts, Weblogic, WebSphere, EJB</td>
                </tr>

                <tr>
                  <th className="bg-light">Web Technologies</th>
                  <td>WAP, XML, HTML, HTTP, XHTML, XSL XML-FO</td>
                </tr>

                <tr>
                  <th className="bg-light">Development Tools</th>
                  <td>MS SQL Server, Oracle, MySQL, Data Modeling Tools</td>
                </tr>

                <tr>
                  <th className="bg-light">Testing Tools</th>
                  <td>
                    TestComplete, WinRunner, QuickTestPro, Rational Suite of testing tools,
                    LoadRunner, MS Web Application Stress Tool, Link Checkers and HTML Validators
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="shadow-sm p-3 mt-4">
              <h4 className="text-primary mb-3 font-weight-bold">What visitors should take away</h4>
              <p className="mb-0">
                This page shows a company that understands how to solve enterprise problems from
                multiple angles: people, process, technology, and delivery discipline. That is the
                kind of experience enterprises want when modernization must happen without
                disruption.
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ExpertiseExperience;
